import type { RuntimeChangeState } from "@/hooks/useRuntimeChange";
import { t, type TranslationKey } from "@/i18n";

// What a running or finished «Betrieb» change says, pinned to the corner of
// the window: the change may start far down the page, and a probe can take a
// minute. `saving` is what a running change says.
export function RuntimeNotice({
  change,
  saving = "ops.saving",
}: {
  change: RuntimeChangeState;
  saving?: TranslationKey;
}) {
  const { busy, notice, dismiss } = change;
  if (busy) {
    return (
      <div class="ops-toast" role="status">
        {t(saving)}
      </div>
    );
  }
  if (!notice) return null;
  return (
    <div
      class={notice.ok ? "ops-toast" : "ops-toast ops-toast-error"}
      role={notice.ok ? "status" : "alert"}
    >
      <span>{notice.text}</span>
      <button
        type="button"
        class="ops-toast-close"
        aria-label={t("ops.notice.close")}
        onClick={dismiss}
      >
        ×
      </button>
    </div>
  );
}
